import React from 'react';

import OutputText from '@ey/canvascoreservices/OutputText';

import Dropdown from '../../../CoreWrappers/Dropdown';
import StyledTrigger from './StyledTrigger';

const DropdownDrydock = () => {
	const renderTrigger = (label = 'TRIGGER') => (onClick) => <StyledTrigger onClick={onClick}>{label}</StyledTrigger>;

	const customRender = (renderLabel = 'renderLabel') => ({id, label, onClick = null}) => {
		const props = {
			key: id,
			title: label
		};
		const txtProps = {
			size: 'L',
			weight: 'light',
			maxWidth: 25,
			ellipsis: true
		};
		if (onClick) props.onClick = onClick;
		return (
			<OutputText {...txtProps}>
				{renderLabel} - {label}
			</OutputText>
		);
	};

	const items = [
		{id: 0, label: 'Item 0', onClick: () => console.log('Clicked item 0')},
		{id: 1, label: 'Item 1', onClick: () => console.log('Clicked item 1')},
		{
			id: 2,
			label: 'Item 2Item 2Item 2Item 2Item 2Item 2Item 2Item 2Item 2Item 2Item 2Item 2Item 2Item 2END',
			onClick: () => console.log('Clicked item 2')
		},
		{
			id: 3,
			label: 'Item 3',
			onClick: () => console.log('Clicked item 3'),
			customRender: customRender('SPECIFIC render 3')
		},
		{id: 4, label: 'Item 4', onClick: () => console.log('Clicked item 4')},
		{id: 5, label: 'Item 5', onClick: () => console.log('Clicked item 5')},
		{id: 6, label: 'Item 6', onClick: () => console.log('Clicked item 6')},
		{id: 7, label: 'Item 7', onClick: () => console.log('Clicked item 7')},
		{id: 8, label: 'Item 8', onClick: () => console.log('Clicked item 8')},
		{id: 9, label: 'Item 9', onClick: () => console.log('Clicked item 9')}
	];

	const renderNormalDropdown = () => {
		const props = {
			items,
			trigger: renderTrigger()
		};

		return (
			<div>
				<Dropdown {...props} />
			</div>
		);
	};

	const renderRightDropdown = () => {
		const props = {
			items,
			renderTrigger: renderTrigger('RIGHT DROPDOWN'),
			placement: 'bottom-right'
		};

		return (
			<div>
				<Dropdown {...props} />
			</div>
		);
	};

	const renderCustomRenderDropdown = () => {
		const props = {
			items,
			renderTrigger: renderTrigger('CUSTOM RENDERS'),
			customRender: customRender('GLOBAL Render')
		};

		return (
			<div>
				<Dropdown {...props} />
			</div>
		);
	};

	return (
		<>
			{renderNormalDropdown()}
			{renderRightDropdown()}
			{renderCustomRenderDropdown()}
		</>
	);
};

export default DropdownDrydock;
